import ko from 'knockout';
import templateMarkup from 'raw-loader!./map-widget.html';
import '../../../components/widgets/map-widget/world';
import Highcharts from "highcharts/highstock.src";
import mapFactory from 'highcharts/modules/map';
mapFactory(Highcharts);


        function loadmap(el) {

            $.getJSON('https://www.highcharts.com/samples/data/jsonp.php?filename=world-population.json&callback=?', function (data) {

                // Correct UK to GB in data
                $.each(data, function () {
                    if (this.code === 'UK') {
                        this.code = 'GB';
                    }
                });

                Highcharts.mapChart(el, {
                    chart: {
                        borderWidth: 1,
                        map: 'custom/world'
                    },

                    lang: {
                        noData: null
                    },

                    title: {
                        text: 'World population 2013 by country'
                    },

                    subtitle: {
                        text: 'Demo of Highcharts map with bubbles'
                    },

                    legend: {
                        enabled: false
                    },

                    mapNavigation: {
                        enabled: true,
                        buttonOptions: {
                            verticalAlign: 'bottom'
                        }
                    },

                    series: [{
                        name: 'Countries',
                        color: '#E0E0E0',
                        enableMouseTracking: false
                    }, {
                        type: 'mapbubble',
                        name: 'Population 2013',
                        joinBy: ['iso-a2', 'code'],
                        data: data,
                        minSize: 4,
                        maxSize: '12%',
                        tooltip: {
                            pointFormat: '{point.code}: {point.z} thousands'
                        }
                    }]
                });

            });
        }

        function MapWidget(params, componentInfo) {

            loadmap(componentInfo.element);

        }

        function MapWidgetFactory(params, componentInfo) {
            return new MapWidget(params, componentInfo);
        }

        MapWidget.prototype.dispose = function () {
        };

        export default {
            viewModel: {
                createViewModel: MapWidgetFactory
            }, template: templateMarkup, synchronous: true
        };
